"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateDrills = void 0;
var tslib_1 = require("tslib");
// (C) 2022-2023 GoodData Corporation
var sdk_model_1 = require("@gooddata/sdk-model");
var effects_1 = require("redux-saga/effects");
var flatMap_1 = tslib_1.__importDefault(require("lodash/flatMap"));
var insight_1 = require("../../events/insight");
var layout_1 = require("../../store/layout");
var insightDrillDefinitionUtils_1 = require("../widgets/validation/insightDrillDefinitionUtils");
var insightDrillDefinitionValidation_1 = require("../widgets/validation/insightDrillDefinitionValidation");
var ui_1 = require("../../store/ui");
function validateDrills(ctx, cmd, widgets) {
    var possibleInvalidDrills, invalidDrills;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.all(widgets
                    .filter(sdk_model_1.isInsightWidget) // KPI drills should not be validated like this and never removed
                    .map(function (widget) { return effects_1.call(validateInsightDrillDefinitions, ctx, cmd, widget); }))];
            case 1:
                possibleInvalidDrills = _a.sent();
                invalidDrills = possibleInvalidDrills.filter(function (_a) {
                    var invalidDrills = _a.invalidDrills;
                    return invalidDrills.length > 0;
                });
                if (!(invalidDrills.length === 0)) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.put(ui_1.uiActions.removeInvalidDrillWidgetRefs(widgets.map(sdk_model_1.widgetRef)))];
            case 2:
                _a.sent();
                return [3 /*break*/, 6];
            case 3: return [4 /*yield*/, effects_1.all(invalidDrills.map(function (drillInfo) {
                    return effects_1.call(removeInsightWidgetDrills, ctx, cmd, drillInfo.widget, drillInfo.invalidDrills);
                }))];
            case 4:
                _a.sent();
                return [4 /*yield*/, effects_1.put(ui_1.uiActions.addInvalidDrillWidgetRefs(invalidDrills.map(function (drill) { return drill.widget.ref; })))];
            case 5:
                _a.sent();
                _a.label = 6;
            case 6: return [2 /*return*/];
        }
    });
}
exports.validateDrills = validateDrills;
function removeInsightWidgetDrills(ctx, cmd, widget, invalidDrills) {
    var notModifiedDrillDefinition;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                notModifiedDrillDefinition = widget.drills.filter(function (drillItem) { return !insightDrillDefinitionUtils_1.existsDrillDefinitionInArray(drillItem, invalidDrills); });
                return [4 /*yield*/, effects_1.put(layout_1.layoutActions.replaceWidgetDrillWithoutUndo({
                        ref: sdk_model_1.widgetRef(widget),
                        drillDefinitions: notModifiedDrillDefinition,
                    }))];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(insight_1.insightWidgetDrillsRemoved(ctx, sdk_model_1.widgetRef(widget), invalidDrills, cmd.correlationId))];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function validateInsightDrillDefinitions(ctx, cmd, widget) {
    var validationData, invalidDrills;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.call(insightDrillDefinitionValidation_1.getValidationData, sdk_model_1.widgetRef(widget), widget.drills, ctx)];
            case 1:
                validationData = _a.sent();
                if (!validationData.drillTargets) {
                    return [2 /*return*/, {
                            invalidDrills: [],
                            widget: widget,
                        }];
                }
                invalidDrills = flatMap_1.default(widget.drills, function (drillItem) {
                    try {
                        insightDrillDefinitionValidation_1.validateDrillDefinition(drillItem, validationData, ctx, cmd);
                        return [];
                    }
                    catch (_a) {
                        return [drillItem];
                    }
                });
                return [2 /*return*/, { invalidDrills: invalidDrills, widget: widget }];
        }
    });
}
//# sourceMappingURL=validateDrills.js.map